class ProductSwiperSlide extends HTMLElement {
    constructor() {
        super();

        this.casouselSlide = this.querySelector('.product-casousel__slideshow');
        this.perView = this.casouselSlide.getAttribute('per-view');
        new Swiper(this.casouselSlide, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            rewind: true,
            speed: 500,
            autoHeight: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                749: {
                    slidesPerView: this.perView,
                    spaceBetween: 0,
                }
            },
        });

        // Move quick-add modals out of the transformed slider so position:fixed works
        this.querySelectorAll('quick-add-modal').forEach((modal) => {
            document.body.appendChild(modal);
        });
    }
}
customElements.define("swiper-container", ProductSwiperSlide);